module.exports = __webpack_public_path__ + "static/logo-a5ada2773b5c47a372903d1b5bb401b6.png";